export default __webpack_public_path__ + "static/media/poly.a9bd4cdb.png";